import axios from "../util/axiosConfig";
import moment from "moment";

import { getErrorMessage } from "../util/ErrorUtils";

export const fetchAccountsAPI = async (payload) => {
  return await axios
    .post(`/api/v1/accounts`, payload)
    .then((response) => {
      if (response.data) {
        return { success: true, data: response.data };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      return { success: false, error: getErrorMessage(error) };
    });
};

export const exportAccountsReportApi = async (payload) => {
  return await axios
    .post(`/api/v1/accounts/export-csv`, payload)
    .then((response) => {
      if (response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        const getReportType = () => {
          let name = "";
          if (payload.uninvoiced) name = "Uninvoiced";
          if (payload.invoiced) name = "Invoiced";
          if (payload.rejected) name = "Rejected";
          if (payload.closed) name = "Closed";
          return name + " " + "items";
        };
        
        const name = `${getReportType()} ${moment(payload.startDate).format("DD-MM-YYYY")} to ${moment(payload.endDate).format("DD-MM-YYYY")}`;
        let fileName = `${name}` + '.csv';
        link.setAttribute('download', fileName); 
        document.body.appendChild(link);
        link.click();
        return { success: true };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      return { success: false, error: getErrorMessage(error) };
    });
}

export const fetchOldAccountsAPI = async (payload) => {
  return await axios
    .post(`/api/v1/fetch-visits-payment-details`, payload)
    .then((response) => {
      if (response.data) {
        return { success: true, data: response.data };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      return { success: false, error: getErrorMessage(error) };
    });
};

export const cancelMedicareInvoice = async (invoiceId, reason) => {
  return await axios
    .post(`/api/v1/invoices/${invoiceId}/cancel`, {
      cancellationReason: reason,
    })
    .then((response) => {
      if (response.data) {
        return { success: true };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      return { success: false, error: error };
    });
};


export const closeInvoiceItemsAPI = async (payload) => {
  return await axios
    .post(`/api/v1/claim/reconcile-invoice-items`, payload)
    .then((response) => {
      if (response.data) {
        return { success: true, data: response.data };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      return { success: false, error: getErrorMessage(error) };
    });
};